module.exports = __webpack_public_path__ + "assets/c857d372e54cfab5c85e7413f934a9fe.svg";